import { checkIfFlagIsToggled } from '@famly/vet_ts-utils_local-storage-config';
/**
 * Whether the KinderConnect TWC capture flow (photo, signature, GPS) should be shown at an
 * attendance entry point. True when either the `KINDER_CONNECT_CAPTURE` debug flag is on, or the
 * backend says capture is required for the relevant child(ren) — centralised here so every entry
 * point checks the same thing, instead of repeating the OR logic.
 *
 * The backend flag itself has to be fetched by the caller and passed in here — entry points should
 * use `useIsKinderConnectCaptureEnabledForChildren(childIds)` instead of calling this directly.
 *
 * `captureEnabled` is a required parameter (not optional/defaulted) on purpose: this makes the
 * compiler flag every call site that hasn't wired up the backend flag yet, rather than letting one
 * silently keep running on the debug flag alone. Don't change it to `captureEnabled?: boolean` —
 * that would look identical but quietly remove the safety net.
 *
 * @param captureEnabled - Whether the backend requires capture for the relevant child(ren), or
 * `undefined` while it hasn't loaded yet (treated as not enabled).
 * @returns Whether KinderConnect capture is enabled for the current user.
 */
export const useIsKinderConnectCaptureEnabled = (captureEnabled) => checkIfFlagIsToggled('KINDER_CONNECT_CAPTURE') || Boolean(captureEnabled);
